import { createContext } from "react";
import {
  HolidaySettings,
  DisplaySettings,
  TimezoneSettings,
  LocaleSettings,
  ProjectSettings,
  Country,
  State,
} from "@/services/userSettings";
import { WeekStartDay } from "@/utils/weekSettings";

export interface UserSettingsContextType {
  holidaySettings: HolidaySettings;
  displaySettings: DisplaySettings;
  timezoneSettings: TimezoneSettings;
  localeSettings: LocaleSettings;
  projectSettings: ProjectSettings;
  effectiveWeekStartDay: WeekStartDay;
  countries: Country[];
  states: State[];
  loading: boolean;
  error: string | null;
  success: string | null;
  updateHolidaySettings: (newSettings: Partial<HolidaySettings>) => Promise<void>;
  updateDisplaySettings: (newSettings: Partial<DisplaySettings>) => Promise<void>;
  updateTimezoneSettings: (newSettings: Partial<TimezoneSettings>) => Promise<void>;
  updateLocaleSettings: (newSettings: Partial<LocaleSettings>) => Promise<void>;
  updateProjectSettings: (newSettings: Partial<ProjectSettings>) => Promise<void>;
  updateLocalSettings: (newSettings: Partial<HolidaySettings>) => void;
  updateLocalDisplaySettings: (newSettings: Partial<DisplaySettings>) => void;
  updateLocalTimezoneSettings: (newSettings: Partial<TimezoneSettings>) => void;
  updateLocalLocaleSettings: (newSettings: Partial<LocaleSettings>) => void;
  updateLocalProjectSettings: (newSettings: Partial<ProjectSettings>) => void;
  setError: (error: string | null) => void;
  setSuccess: (success: string | null) => void;
}

export const UserSettingsContext = createContext<UserSettingsContextType | undefined>(undefined);
